import { EventEmitter, Injectable } from '@angular/core';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { Observable } from 'rxjs';

import { locales } from 'src/app/locales';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  defaultLocaleCode =
    navigator.language.includes('es-') || navigator.language === 'es'
      ? 'es-MX'
      : 'en';

  constructor(
    private i18n: NzI18nService,
    private translateService: TranslateService
  ) {}

  onLangChange(): EventEmitter<LangChangeEvent> {
    return this.translateService.onLangChange;
  }

  getCurrentLang() {
    return this.translateService.currentLang;
  }

  getLocalObj() {
    const localeTypeObj = {};
    locales.forEach((locale) => {
      localeTypeObj[locale.code] = locale;
    });

    return localeTypeObj;
  }

  getCurrentOxioLocaleCode() {
    return this.getLocalObj()[this.getCurrentLang()].oxioCode;
  }

  getCurrentLocaleISO_639Code() {
    return this.getLocalObj()[this.getCurrentLang()].ngZorroCode.locale;
  }

  stream(
    key: string | string[],
    interpolateParams?: Object
  ): Observable<string | any> {
    return this.translateService.stream(key, interpolateParams);
  }

  instant(key: string | string[], interpolateParams?: Object): any {
    return this.translateService.instant(key, interpolateParams);
  }

  initLocale() {
    let code;
    const savedCode = this.getLocale();
    this.translateService.addLangs(locales.map((locale) => locale.code));

    if (savedCode) {
      code = savedCode;
    } else {
      code = this.defaultLocaleCode;
    }

    this.translateService.setDefaultLang(code); // this language will be used as a fallback when a translation isn't found in the current language

    this.set(code); // the lang to use, if the lang isn't available, it will use the current loader to get them
  }

  set(code: string) {
    const locale = this.getLocalObj();
    this.saveLocale(code);
    this.translateService.use(code);
    this.i18n.setLocale(locale[code].ngZorroCode);
    this.i18n.setDateLocale(locale[code].dateFnsCode);
  }

  /**
   * Get Locale from local storage
   * @method getLocale
   * @returns {string} Locale
   */
  getLocale(): String {
    return window.localStorage['userLocale'];
  }

  /**
   * Save Locale to local storage
   * @method saveLocale
   * @param code locale code
   */
  saveLocale(code: String) {
    window.localStorage['userLocale'] = code;
  }

  /**
   * Destroy Locale in local storage
   * @method destroyLocale
   */
  destroyLocale() {
    window.localStorage.removeItem('userLocale');
  }
}
